// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoBubble_root__3oKvf","infoText":"InfoBubble_infoText__6ykaK","imageContainer":"InfoBubble_imageContainer__3B7jk"};